<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Epigraph-rw exclude-auto-rw page-open-right-rw" epub:type="frontmatter epigraph" id="Epigraph1">
<div class="epigraph-rw" id="epigraph1">
<p class="ep1-rw" id="p27">More than any other time in history mankind faces a crossroads. One path leads to despair and utter hopelessness, the other to total extinction. Let us pray we have the wisdom to choose correctly.</p>
<p class="source-rw" id="source1">—Woody Allen</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s005-Epigraph-01.vue?186cb17f